import {Language} from "../store/languageContext.ts";
import {css, cx} from "@pandacss/css";
import {FC} from "react";
import {font} from "../style/typography.tsx";

interface Props {
    language: Language,
    onClick: () => void
}

const languageButtonClass = css({
    border: "1px solid",
    borderColor: "primary.500",
    padding: "8px 16px",
    borderRadius: "100px",
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer'
})

const LanguageButton: FC<Props> = ({language, onClick}) => {
    return <button className={cx(languageButtonClass, font('body', '2', 'semiBold'))} onClick={onClick}>
        <span>{language.flagEmoji}</span><span>{language.localName}</span>
    </button>
}

export default LanguageButton